import React from 'react';
import animateTo from 'src/common/bc-scroll';
import { getText } from 'src/utils/i18n';
import eventManager from '@alife/scc-event-manager/event-manager';
import NavSlider from 'src/common/nav-slider';
import safeLog from '@alife/bc-safe-log';
import './index.scss';

const SCROLL_CHECK_INTERVAL = 20;
const ACTIVE_CHECK_HEIGHT = 40;

class Anchors extends React.Component {
  constructor(props) {
    super(props);

    this.id = props.id;

    this.state = {
      anchors: [],
      active: '',
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', () => this.onWinScroll());
    eventManager.on('setAnchors', this.setAnchors.bind(this));

    eventManager.on('detailTab:goto', options => {
      const { id, key } = options || {};
      if (this.id !== id) {
        return;
      }
      this.scrollToAnchor(key);
    });
  }

  // 导航渲染时如果不可见，要在tab切换后重新渲染一次，以保证尺寸计算正确
  componentDidUpdate(prevProps) {
    if (
      prevProps.activeId !== this.props.activeId &&
      this.props.activeId === this.id
    ) {
      // eslint-disable-next-line
      this.setState({ anchors: this.state.anchors.slice() });
    }
  }

  onWinScroll() {
    clearTimeout(this._scrollTimer);
    this._scrollTimer = setTimeout(
      () => this.checkActive(),
      SCROLL_CHECK_INTERVAL,
    );
  }

  // 按dom顺序设置导航
  setAnchors(options) {
    const { onChange, i18n } = this.props;
    const { id, anchors } = options || {};
    if (!id || id !== this.id || !anchors || !anchors.length) {
      return;
    }

    anchors.forEach(anchor => {
      if (anchor.textKey) {
        anchor.text = getText(i18n, anchor.textKey);
      }
    });
    this.setState({ anchors }, () => {
      this.checkActive();
      onChange && onChange();
    });
    return false;
  }

  scrollToAnchor = id => {
    const index = this.state.anchors.findIndex(item => item && item.id === id);
    const { dom } = this.state.anchors[index] || {};
    if (!dom) {
      return;
    }

    const rectAnchor = dom.getBoundingClientRect();
    const rectTab = this.el.getBoundingClientRect();
    animateTo(window.pageYOffset + (rectAnchor.top - rectTab.bottom));
    this.setState({ active: id });

    safeLog(
      '/sc.details.tabNav',
      'CLK',
      `tabId=${this.id}&index=${index}&navId=${id}`,
    );
  };

  isVisible() {
    return this.el && this.el.offsetWidth > 0 && this.el.offsetHeight > 0;
  }

  checkActive() {
    if (!this.isVisible()) {
      return;
    }

    const { anchors } = this.state;
    const rectTab = this.el.getBoundingClientRect();
    const topMod = anchors.find((item, index) => {
      const { dom } = item || {};
      if (!dom) {
        return false;
      }
      const rect = dom.getBoundingClientRect() || {};
      const domNext = anchors[index + 1] && anchors[index + 1].dom;
      const rectNext = domNext && domNext.getBoundingClientRect();
      // 最后一个节点
      if (!rectNext) {
        return rect.top <= rectTab.bottom + ACTIVE_CHECK_HEIGHT;
      }

      // 离nav最近的节点
      if (
        rect.top <= rectTab.bottom + ACTIVE_CHECK_HEIGHT &&
        rectNext.top > rectTab.bottom + ACTIVE_CHECK_HEIGHT
      ) {
        return true;
      }

      return false;
    });
    this.setState({ active: topMod && topMod.id });
  }

  render() {
    const { anchors, active } = this.state;
    if (!anchors || !anchors.length) {
      return null;
    }

    return (
      <div className="tab-anchors" ref={el => (this.el = el)}>
        <NavSlider
          navs={anchors}
          active={active}
          onChange={this.scrollToAnchor}
        />
      </div>
    );
  }
}

export default Anchors;
